var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cms-view"},[(['/',`/${_vm.$i18n.locale.split('-')[0]}`].includes(_vm.$route.path))?[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(
                    [
                        _vm.orderProcess.STEPS.NO_ORDER_ONGOING,
                        _vm.orderProcess.STEPS.ORDER_COMPLETED,
                    ].includes(_vm.currentOrderProcessStep) &&
                        [
                            _vm.viewports.DESKTOP.name,
                            _vm.viewports.WIDESCREEN.name,
                            _vm.viewports.FULL_HD.name,
                        ].includes(_vm.currentViewport)
                )?_c('UploadHero'):(
                    ![
                        _vm.viewports.MOBILE.name,
                        _vm.viewports.TABLET.name,
                    ].includes(_vm.currentViewport)
                )?_c('CheckoutHero'):_vm._e()],1),(
                [
                    _vm.viewports.DESKTOP.name,
                    _vm.viewports.WIDESCREEN.name,
                    _vm.viewports.FULL_HD.name,
                ].includes(_vm.currentViewport)
            )?_c('Steps'):_vm._e()]:_vm._e(),_c('transition',{attrs:{"name":"fade"}},[(_vm.pageContent)?_c('div',{staticClass:"cms-view-content",class:{'is-subpage':!['/'].includes(_vm.$route.path)}},_vm._l((_vm.pageContent),function(element){return _c('CMSViewComponent',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isOrderProcessOngoing),expression:"!isOrderProcessOngoing"}],key:'cms_content_element_' + element.id,attrs:{"element":element}})}),1):_vm._e()]),(_vm.$route.path === '/kontakt')?_c('ContactForm'):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }